var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "slider w-full flex md:block overflow-x-auto md:overflow-x-hidden overflow-y-hidden scrolling-touch",
    },
    _vm._l(_vm.palettes, function (palette, paletteIndex) {
      return _c(
        "div",
        {
          key: paletteIndex,
          staticClass: "slide w-auto",
          class: `palette-${palette.id}`,
        },
        [
          _c("div", { staticClass: "slide__inner" }, [
            _c(
              "div",
              {
                staticClass:
                  "bg-smoke rounded-xl pt-4 md:pt-6 pb-4 md:pb-5 px-3 md:px-4",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-between items-end px-2 mb-3 md:mb-4",
                  },
                  [
                    _c("div", { staticClass: "mr-5" }, [
                      !_vm.isCoatingProduct
                        ? _c(
                            "h4",
                            {
                              staticClass:
                                "text-xxs font-semibold uppercase tracking-widest",
                            },
                            [
                              _vm._v(
                                "\n              Palette " +
                                  _vm._s(paletteIndex + 1) +
                                  "/" +
                                  _vm._s(_vm.palettes.length) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h3", [_vm._v(_vm._s(palette.title))]),
                    ]),
                    _vm._v(" "),
                    _vm.swatchBook
                      ? _c("ProductSwatchBook", {
                          attrs: {
                            product: _vm.swatchBook,
                            title: palette.title,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center h-13 rounded-full bg-white space-x-3 px-1.25",
                  },
                  _vm._l(palette.colours, function (colour) {
                    return _c(
                      "div",
                      { key: colour.id },
                      [
                        _vm.isColourPage || _vm.isPaintProduct
                          ? _c("ColourSelectorPaintButton", {
                              attrs: {
                                colour: colour,
                                "selected-colour": _vm.selectedColour,
                              },
                              on: {
                                "handle-click": _vm.handleClick,
                                "change-colour": function ($event) {
                                  return _vm.$emit("change-colour", colour)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCoatingProduct
                          ? _c("ColourSelectorCoatingButton", {
                              attrs: {
                                colour: colour,
                                "selected-colour": _vm.selectedColour,
                              },
                              on: {
                                "change-colour": function ($event) {
                                  return _vm.$emit("change-colour", colour)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }